import Types from "./types";
import { BffDataAU, SecureListingServiceAU } from "../../../service";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";

const updateSelectedCar = (carId) => ({
    type: Types.UPDATE_SELECTED_CAR,
    carId
});

const showWishlistPopup = (showMyWishlist) => ({
    type: Types.SHOW_WISHLIST_POPUP,
    showMyWishlist
});

const fetchWishlistedCarsListInitiated = () => ({
    type: Types.FETCH_WISHLISTED_CARS_LIST_INIT
});

const fetchWishlistedCarsListSuccess = (data, params) => ({
    type: Types.FETCH_WISHLISTED_CARS_LIST_SUCCESS,
    data,
    params
});

const fetchWishlistedCarsListFailure = (error) => ({
    type: Types.FETCH_WISHLISTED_CARS_LIST_FAILURE,
    error
});

const fetchWishlistedCarsList = (token) => (dispatch) => {
    dispatch(fetchWishlistedCarsListInitiated());
    SecureListingServiceAU.fetchWishlistCarsList(token)
        .then((response) => {
            dispatch(fetchWishlistedCarsListSuccess(response.data));
        })
        .catch((error) => {
            dispatch(fetchWishlistedCarsListFailure(error));
        });
};

const fetchWishlistedCarsInitiated = () => ({
    type: Types.FETCH_WISHLISTED_CARS_INIT
});

const fetchWishlistedCarsSuccess = (data, params) => ({
    type: Types.FETCH_WISHLISTED_CARS_SUCCESS,
    data,
    params
});

const fetchWishlistedCarsFailure = (error) => ({
    type: Types.FETCH_WISHLISTED_CARS_FAILURE,
    error
});

const fetchWishlistedCars = (token, params = {}) => (dispatch) => {
    dispatch(fetchWishlistedCarsInitiated());
    SecureListingServiceAU.fetchWishlistCars(token, params)
        .then((response) => {
            dispatch(fetchWishlistedCarsSuccess(response.data, params));
        })
        .catch((error) => {
            dispatch(fetchWishlistedCarsFailure(error));
        });
};

const addOrRemoveFromWishlistInitiated = () => ({
    type: Types.ADD_OR_REMOVE_FROM_WISHLIST_INIT
});

const addOrRemoveFromWishlistSuccess = (data, isDesktopWishlistAdoptionVariant) => ({
    type: Types.ADD_OR_REMOVE_FROM_WISHLIST_SUCCESS,
    data,
    isDesktopWishlistAdoptionVariant
});

const addOrRemoveFromWishlistFailure = (error) => ({
    type: Types.ADD_OR_REMOVE_FROM_WISHLIST_FAILURE,
    error
});

const addOrRemoveFromWishlist = (token, data) => (dispatch, getState) => {
    const { abExperiment: { desktopWishlistAdoption } } = getState();
    const isDesktopWishlistAdoptionVariant = getAbExpirementVariant(desktopWishlistAdoption, EXPERIMENT_TYPE.VARIANT_B);
    return new Promise((resolve, reject) => {
        dispatch(addOrRemoveFromWishlistInitiated());
        SecureListingServiceAU.addOrRemoveFromWishlist(token, data)
            .then((response) => {
                dispatch(addOrRemoveFromWishlistSuccess(response.data, isDesktopWishlistAdoptionVariant));
                if (isDesktopWishlistAdoptionVariant && !data.shortListed) {
                    dispatch(fetchWishlistedCars(token, {
                        wishlistAdoptionVariant: true
                    }));
                }
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(addOrRemoveFromWishlistFailure(error));
                reject(error);
            });
    });
};

const updateWishlistNoteInitiated = () => ({
    type: Types.UPDATE_WISHLIST_NOTE_INIT
});

const updateWishlistNoteSuccess = (data) => ({
    type: Types.UPDATE_WISHLIST_NOTE_SUCCESS,
    data
});

const updateWishlistNoteFailure = (error) => ({
    type: Types.UPDATE_WISHLIST_NOTE_FAILURE,
    error
});

const updateWishlistNote = (data) => (dispatch, getState) => {
    const { user: { secureToken } } = getState();
    dispatch(updateWishlistNoteInitiated());
    BffDataAU.updateWishlistNote(secureToken, data)
        .then((response) => {
            dispatch(updateWishlistNoteSuccess(response.data));
            return response.data;
        })
        .catch((error) => {
            dispatch(updateWishlistNoteFailure(error));
            return error;
        });
};

const resetWishlist = () => ({
    type: Types.RESET_WISHLIST
});

const fetchSharableWishlistInitiated = () => ({
    type: Types.FETCH_SHARABLE_WISHLIST_INIT
});

const fetchSharableWishlistSuccess = (data) => ({
    type: Types.FETCH_SHARABLE_WISHLIST_SUCCESS,
    data
});

const fetchSharableWishlistFailure = (error) => ({
    type: Types.FETCH_SHARABLE_WISHLIST_FAILURE,
    error
});

const fetchSharableWishlist = (params) => (dispatch) => {
    dispatch(fetchSharableWishlistInitiated());
    return new Promise((resolve, reject) => {
        BffDataAU.fetchSharableWishlist(params)
            .then((response) => {
                dispatch(fetchSharableWishlistSuccess(response.data));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchSharableWishlistFailure(error));
                reject(error);
            });
    });
};

const showPrioritizationModal = (showPersonalisationModal) => ({
    type: Types.SHOW_PERSONALISATION_MODAL_STATE,
    showPersonalisationModal
});

const setLastWishlistedCarId = (carId) => ({
    type: Types.SET_LAST_WISHLISTED_CAR_ID,
    carId
});

export {
    updateSelectedCar,
    showWishlistPopup,
    fetchWishlistedCars,
    fetchWishlistedCarsList,
    addOrRemoveFromWishlist,
    resetWishlist,
    updateWishlistNote,
    fetchSharableWishlist,
    showPrioritizationModal,
    setLastWishlistedCarId
};
